import { Tooltip } from '@mui/material';
import LinkWrapper from '../../LinkWrapper';
import { useMenuNavigation } from './useMenuNavigation';
import { useQuickAccessShortcuts } from './useQuickAccessShortcuts';

/**
 * Fila de accesos rápidos al pie del sidebar, encima del bloque de usuario.
 * Son enlaces sólo de icono, así que cada uno lleva su tooltip y su nombre
 * accesible. Al ser enlaces de verdad se pueden abrir en otra pestaña o ventana
 * con el clic derecho, ⌘/Ctrl+clic o el botón central.
 */
export default function SidebarQuickAccess(): React.ReactElement | null {
    const { go } = useMenuNavigation();
    const shortcuts = useQuickAccessShortcuts();

    if (shortcuts.length === 0) return null;

    // Rejilla de 4 como en competitions. Los atajos de TPV y aforo dependen de
    // los módulos del centro, así que puede haber menos de cuatro.
    return (
        <div
            id="tour-quick-access"
            className="border-sidebar-border grid grid-cols-4 gap-2 border-t px-1 pt-3"
        >
            {shortcuts.map((shortcut) => (
                <Tooltip
                    key={shortcut.id}
                    title={shortcut.label}
                    arrow
                    placement="top"
                    enterDelay={300}
                >
                    {/* El tooltip de MUI necesita un hijo al que pasarle la
                        referencia, y el enlace no la reenvía: va envuelto. */}
                    <span className="flex">
                        <LinkWrapper
                            href={shortcut.href}
                            callback={() => go({ url: shortcut.href })}
                            ariaLabel={shortcut.label}
                            className="bg-sidebar-accent/40 text-sidebar-foreground/80 hover:bg-sidebar-accent hover:text-sidebar-foreground flex h-11 w-full cursor-pointer items-center justify-center rounded-lg transition-colors"
                        >
                            {/* Ancla del tour guiado (useMenusTour busca
                                #header #timetable y compañía). */}
                            <span id={shortcut.id} className="flex">
                                {shortcut.icon}
                            </span>
                        </LinkWrapper>
                    </span>
                </Tooltip>
            ))}
        </div>
    );
}
